module.exports = __webpack_public_path__ + "media/images/card-img-a01871f2f780b8a72f79372b19e850d8.png";